import { resendCustomerUserInvitationApi } from "@/api/services/main/customer-user";
import { TCustomerUserDetailDto } from "@/api/services/main/customer-user/dtos/customer-user.dto";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { Button } from "@/components/elements/Button";
import { IconOutgoingMail, IconSave } from "@/assets/icons";
import { canResendInvitation } from "@/features/customer-user/constant/statusHelpers";
import { AppRoutes } from "@/routes/config";
import { USER_STATUS } from "@/types/enum";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { Stack } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type TProps = { user?: TCustomerUserDetailDto };

export const CustomerUserFormFooter: FC<TProps> = ({ user }) => {
  const navigate = useNavigate();
  const canResend = !!user && user.status !== USER_STATUS.DISABLED && canResendInvitation(user.accountStatus);

  const handleResendInvitation = async () => {
    if (!user) return;
    try {
      await resendCustomerUserInvitationApi(user.id);
      toast.success("登録メールを再送信しました。");
    } catch (error) {
      showError(error);
    }
  };

  return (
    <FooterContainer>
      <Button variant="ghost" size="sm" type="button" onClick={() => navigate(AppRoutes.customerUsers)}>
        戻る
      </Button>
      <Stack direction="row" gap="12px">
        {user && (
          <Button
            variant="outline"
            size="sm"
            type="button"
            disabled={!canResend}
            onClick={handleResendInvitation}
            startIcon={<IconOutgoingMail />}
            sx={{ minWidth: "102px" }}
          >
            再招待
          </Button>
        )}
        <Button variant="primary" size="sm" type="submit" startIcon={<IconSave />}>
          保存
        </Button>
      </Stack>
    </FooterContainer>
  );
};
